module.exports = __webpack_public_path__ + "static/media/frames-for-detective2.ab9ad70c.png";